import tools from '../../../../assets/javascript/tools.js'
export default {
	columns: {
		// title: {
		//     label: "档案归类",
		//     visible: true,
		//     width: "100",
		//     align: "left",
		// },
		customerName: {
			label: '顾客姓名',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		mobile: {
			label: '联系方式',
      visible: true,
      width:'auto',
			minWidth: '120',
			align: 'left',
		},
		shopName: {
			label: '建档门店',
			visible: true,
			width: '320',
			align: 'left',
		},
		staffName: {
			label: '建档技师',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		categoryName: {
			label: '部位',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		amount: {
			label: '档案金额',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		realPayAmount: {
			label: '实收金额',
			visible: true,
			width: 'auto',
			align: 'left',
		},

		repairStatusCn: {
			label: '档案状态',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		// repairStatusCn: {
		//     label: "状态",
		//     visible: true,
		//     width: "100",
		//     align: "left",
		// },
		recordTime: {
			label: '建档时间',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		nextRepairTime: {
			label: '下次登记时间',
			visible: true,
			formatDay: true,
			width: 'auto',
			align: 'left',
		},
		validEndTime: {
			label: '过期/完成时间',
			visible: true,
			formatDay: true,
			width: '120',
			align: 'left',
		},
	},
}
